import script from "./ChatGPT.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatGPT.vue?vue&type=script&setup=true&lang=js"

import "./ChatGPT.vue?vue&type=style&index=0&id=c15bc378&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c15bc378"]])

export default __exports__